module.exports = __webpack_public_path__ + "static/media/Angaare_Eng.3dd22481.png";